import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import measureoverlay from "../../../../assets/videos/docs/rulers/measure.mp4";
import xmltree from "../../../../assets/images/docs/xml/tree.png";
import findelement from "../../../../assets/images/docs/findelement.png";
import linkedin241 from "../../../../assets/images/blogs/pp241/linkedin.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  measureoverlay,
  xmltree,
  findelement,
  linkedin241,
  React
};